import { render, staticRenderFns } from "./LabelDrawerForm.vue?vue&type=template&id=860e6d48&"
import script from "./LabelDrawerForm.vue?vue&type=script&lang=js&"
export * from "./LabelDrawerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports